export const UNIDENTIFIED = "UNIDENTIFIED";
export const TUPAS = "TUPAS";
export const OP = "OP";

export const PERSON = "PERSON";
export const BUSINESS = "BUSINESS";

export const EMPTY = "";

export const INITIAL_VALUE = {
  value: EMPTY,
  included: false,
  required: true,
  error: false,
  dirty: false,
};

export const FI = "fi";
export const EN = "en";

export const TEL = "tel";
export const STREET_ADDRESS = "street-address";
export const POSTAL_CODE = "postal-code";

export const EMPTY_ERROR_CODE = "empty";
export const INVALID_TEXT_AREA_ERROR_CODE = "invalidTextArea";
export const INVALID_TEXT_FIELD_ERROR_CODE = "invalid";

export const FEEDBACK_TYPES = ["positive", "negative", "development_proposal"];

export const PHONE = "phone";
export const EMAIL = "email";
export const WEB_MESSAGE = "web_message";
export const CONTACT_METHODS = {
  UNIDENTIFIED: [PHONE, EMAIL],
  TUPAS: [PHONE, EMAIL],
  PERSON: [WEB_MESSAGE, PHONE],
  BUSINESS: [WEB_MESSAGE, PHONE],
};

export const BANKING = "banking";
export const INSURANCE = "insurance";
export const OTHER = "other";
export const FEEDBACK_TARGETS = [BANKING, INSURANCE, OTHER];
export const CUSTOMER_FEEDBACK_INSURANCE_SALES_CUSTOMER_SERVICE =
  "customer_feedback_insurance_sales_customer_service";
export const CUSTOMER_FEEDBACK_CLAIMS_INDEMNITIES =
  "customer_feedback_claims_indemnities";
export const CUSTOMER_FEEDBACK_INSURANCE_SAVING =
  "customer_feedback_insurance_saving";

export const FEEDBACK_SUBJECTS = {
  banking: [
    "accounts_cards_payments",
    "customer_feedback_loans_finance",
    "customer_feedback_saving_investing",
    "customer_service",
    "customer_feedback_mobile_service",
    "customer_feedback_web_service",
    "communication_marketing",
    "customer_feedback_proprietary",
    "other",
  ],
  insurance: [
    CUSTOMER_FEEDBACK_INSURANCE_SALES_CUSTOMER_SERVICE,
    CUSTOMER_FEEDBACK_CLAIMS_INDEMNITIES,
    CUSTOMER_FEEDBACK_INSURANCE_SAVING,
  ],
};

export const INVALID_EMAIL_CHARS = [
  "<",
  ">",
  ")",
  "(",
  ";",
  "/",
  '"',
  "'",
  "‘",
  "’",
  "“",
  "”",
];

export const MAX_ERROR_COUNT = 3;

export const HA = "HA";
export const YA = "YA";

export const INSURANCE_FEEDBACK = "vakuutuspalaute";
export const BANK_FEEDBACK = "pankkipalaute";
export const INSURANCE_DAMAGE = "customer_feedback_insurance_damage";
export const SOURCE = "palautelomake";

export const ASSIGNEE_GROUPS = {
  personalFeedback: "personal", // Henkilöasiakkaiden palautekäsittely
  insuranceFeedback: "indemnity", // Vahinkovakuutuksen palautekäsittely
  corporateFeedback: "business", // Yritysasiakkaiden palautekäsittely
  indemnificationFeedback: "indemnification", // "Korvauspalvelun asiakaspalautteet"
  lifeInsuranceFeedback: "op_life_insurance", // OP Henkivakuutuksen palautekäsittely
};

export const TOPIC_PREFIX = "Op.fi:";

export const ANALYTICS_EVENTS = {
  open: { name: "start", description: "vaihe 1, lomake avattu" },
  start: { name: "step", description: "vaihe 2, lomake aloitettu" },
  end: { name: "completed", description: "viimeinen vaihe, lomake lahetetty" },
  error: { name: "error", description: "TechnicalError" },
};

export const LANGUAGES = {
  fi: "fi_fi",
  en: "en_us",
  sv: "sv_se",
};

export const REFRESH_SESSION_INTERVAL = 300000; // 5 minutes
export const MAX_SESSION_TIMEOUT = 60 * 60000; // 60 minutes
export const MODAL_TIMEOUT = 90000; // 90 seconds
export const USER_INACTIVITY_TIMEOUT = 15 * 60000; // 15 minutes

export const SUBJECT_KEY = "subject";
